<template>
  <div class="container">
    <el-tabs v-model="activeName" @tab-click="tabClick">
      <el-tab-pane label="深挖邮箱(域名)" name="deepMailsTask">
        <el-row>
          <el-input v-model="taskKeywords" placeholder="请输入任务名称" clearable style="width: 300px; margin-right: 10px;"
            @clear="queryDeepEmailsTaskList(true)"></el-input>
          <el-button @click="queryDeepEmailsTaskList(true)" icon="el-icon-search" circle title="搜索"></el-button>
          <el-button @click="createTask()" icon="el-icon-plus" circle title="创建"></el-button>
        </el-row>
        <el-table :data="deepEmailsTaskList" stripe v-loading="tableLoading" height="650">
          <el-table-column prop="task_name" label="任务名称">
          </el-table-column>
          <el-table-column prop="" label="原始文件">
            <template v-slot="scope">
              <el-link type="primary" @click="taskFileDownload(scope.row)">{{ scope.row.file_name }}</el-link>
            </template>
          </el-table-column>
          <el-table-column prop="total" label="总数" width="100">
          </el-table-column>
          <el-table-column prop="grab_rate" label="捕获率" sortable width="100"
            :sort-method="(a, b) => { return a.grab_rate - b.grab_rate }">
            <template v-slot="scope">
              <em v-if="scope.row.percentage >= 100">{{ scope.row.grab_rate + '%' }}</em>
              <em v-if="scope.row.percentage < 100">-</em>
            </template>
          </el-table-column>
          <el-table-column prop="creator" label="创建人" width="100">
          </el-table-column>
          <el-table-column prop="created_at" label="创建时间" sortable width="170">
          </el-table-column>
          <el-table-column prop="percentage" label="任务进度" sortable width="170">
            <template v-slot="scope">
              <em v-if="scope.row.paused === true">已暂停</em>
              <em v-else>
                <el-progress :text-inside="true" :stroke-width="15" :percentage="scope.row.percentage"
                  :text-color="scope.row.percentage < 50 ? '#000' : '#FFF'" :color="colors"></el-progress>
              </em>
            </template>
          </el-table-column>
          <el-table-column prop="" label="文件下载">
            <template v-slot="scope">
              <em v-if="!scope.row.download_file">-</em>
              <el-link type="primary" v-if="scope.row.download_file" @click="resultFileDownload(scope.row)">{{
                scope.row.download_file }}</el-link>
            </template>
          </el-table-column>
          <el-table-column prop="" label="操作">
            <template v-slot="scope">
              <el-button v-if="scope.row.percentage >= 100 || scope.row.paused" type="danger" icon="el-icon-delete"
                @click="deepEmailsTaskDel(scope.row)" title="删除" circle></el-button>
              <el-button v-if="scope.row.paused" type="success" icon="el-icon-video-play"
                @click="taskPausedToggle(scope.row)" title="继续" circle></el-button>
              <el-button v-if="!scope.row.paused && scope.row.percentage < 100" type="warning"
                icon="el-icon-video-pause" @click="taskPausedToggle(scope.row)" title="暂停" circle></el-button>
            </template>
          </el-table-column>
        </el-table>
        <div class="pagenation">
          <el-pagination background layout="total, sizes, prev, pager, next" :total="taskTotal"
            @size-change="changeTaskSize" @current-change="currentTaskChange" :page-sizes="[10, 20, 50, 100]"
            :page-size="taskSize">
          </el-pagination>
        </div>
        <el-dialog title="创建任务" :visible.sync="createTaskVisable">
          <el-form :model="createTaskForm" label-width="120px" :rules="createTaskRules" ref="createTaskForm">
            <el-form-item label="任务名称" prop="task_name">
              <el-col :span="17">
                <el-input placeholder="请输入内容" v-model="createTaskForm.task_name"></el-input>
              </el-col>
            </el-form-item>
            <el-form-item label="选择文件">
              <el-col>
                <el-upload class="upload-demo" drag :action="uploadApi" :file-list="taskFileList" accept=".xls,.xlsx"
                  :limit="1" :headers="headersObj" :on-success="taskUploadSuccess">
                  <i class="el-icon-upload"></i>
                  <div class="el-upload__text">将文件拖到此处，或<em>点击上传</em></div>
                  <div class="el-upload__tip" slot="tip">只能上传xls/xlsx文件</div>
                </el-upload>
              </el-col>
            </el-form-item>
          </el-form>
          <div slot="footer" class="dialog-footer">
            <el-button @click="cancelCreateTask">取 消</el-button>
            <el-button type="primary" @click="saveCreateTask" v-loading="deepMailsTaskLoading">保 存</el-button>
          </div>
        </el-dialog>
      </el-tab-pane>
      <el-tab-pane label="贸易数据(公司名)" name="tradeDataTask">
        <el-row>
          <el-input v-model="tradeDataTaskKeywords" placeholder="请输入任务名称" clearable
            style="width: 300px; margin-right: 10px;" @clear="queryTradeDataTaskList(true)"></el-input>
          <el-button @click="queryTradeDataTaskList(true)" icon="el-icon-search" circle title="搜索"></el-button>
          <el-button @click="createTradeDataTask()" icon="el-icon-plus" circle title="创建"></el-button>
        </el-row>
        <el-table :data="tradeDataTaskList" stripe v-loading="tableLoading" height="650">
          <el-table-column prop="task_name" label="任务名称">
          </el-table-column>
          <el-table-column prop="" label="原始文件">
            <template v-slot="scope">
              <el-link type="primary" @click="taskFileDownload(scope.row)">{{ scope.row.file_name }}</el-link>
            </template>
          </el-table-column>
          <el-table-column prop="total" label="总数" width="100">
          </el-table-column>
          <el-table-column prop="grab_rate" label="捕获率" sortable width="100"
            :sort-method="(a, b) => { return a.grab_rate - b.grab_rate }">
            <template v-slot="scope">
              <em v-if="scope.row.percentage >= 100">{{ scope.row.grab_rate + '%' }}</em>
              <em v-if="scope.row.percentage < 100">-</em>
            </template>
          </el-table-column>
          <el-table-column prop="creator" label="创建人" width="100">
          </el-table-column>
          <el-table-column prop="created_at" label="创建时间" sortable width="170">
          </el-table-column>
          <el-table-column prop="percentage" label="任务进度" sortable width="170"
            :sort-method="(a, b) => { return a.percentage - b.percentage }">
            <template v-slot="scope">
              <em v-if="scope.row.paused === true">已暂停</em>
              <em v-else>
                <el-progress :text-inside="true" :stroke-width="15" :percentage="scope.row.percentage"
                  :text-color="scope.row.percentage < 50 ? '#000' : '#FFF'" :color="colors"></el-progress>
              </em>
            </template>
          </el-table-column>
          <el-table-column prop="" label="文件下载">
            <template v-slot="scope">
              <em v-if="!scope.row.download_file && scope.row.percentage < 100">-</em>
              <em v-if="!scope.row.download_file && scope.row.percentage == 100">正在尝试重新获取空值, 请稍候</em>
              <el-link type="primary" v-if="scope.row.download_file" @click="resultFileDownload(scope.row)">{{
                scope.row.download_file }}</el-link>
            </template>
          </el-table-column>
          <el-table-column prop="" label="操作">
            <template v-slot="scope">
              <el-button v-if="scope.row.percentage >= 100 || scope.row.paused" type="danger" icon="el-icon-delete"
                @click="deepEmailsTaskDel(scope.row)" title="删除" circle></el-button>
              <el-button v-if="scope.row.paused" type="success" icon="el-icon-video-play"
                @click="taskPausedToggle(scope.row)" title="继续" circle></el-button>
              <el-button v-if="!scope.row.paused && scope.row.percentage < 100" type="warning"
                icon="el-icon-video-pause" @click="taskPausedToggle(scope.row)" title="暂停" circle></el-button>
            </template>
          </el-table-column>
        </el-table>
        <div class="pagenation">
          <el-pagination background layout="total, sizes, prev, pager, next" :total="tradeDataTaskTotal"
            @size-change="changeTradeDataTaskSize" @current-change="currentTradeDataTaskChange"
            :page-sizes="[10, 20, 50, 100]" :page-size="taskSize">
          </el-pagination>
        </div>
        <el-dialog title="创建任务" :visible.sync="createTradeDataTaskVisable">
          <el-form :model="createTradeDataTaskForm" label-width="120px" :rules="createTradeDataTaskRules"
            ref="createTradeDataTaskForm">
            <el-form-item label="任务名称" prop="task_name">
              <el-col :span="17">
                <el-input placeholder="请输入内容" v-model="createTradeDataTaskForm.task_name"></el-input>
              </el-col>
            </el-form-item>
            <el-form-item label="选择文件">
              <el-col>
                <el-upload class="upload-demo" drag :action="uploadApi" :file-list="tradeDataTaskFileList"
                  accept=".xls,.xlsx" :limit="1" :headers="headersObj" :on-success="tradeDataTaskUploadSuccess">
                  <i class="el-icon-upload"></i>
                  <div class="el-upload__text">将文件拖到此处，或<em>点击上传</em></div>
                  <div class="el-upload__tip" slot="tip">只能上传xls/xlsx文件</div>
                </el-upload>
              </el-col>
            </el-form-item>
          </el-form>
          <div slot="footer" class="dialog-footer">
            <el-button @click="cancelCreateTradeDataTask">取 消</el-button>
            <el-button type="primary" @click="saveCreateTradeDataTask" v-loading="tradeDataTaskLoading">保 存</el-button>
          </div>
        </el-dialog>
      </el-tab-pane>
      <el-tab-pane label="筛选联系人" name="screenContactors">
        <el-row>
          <el-input v-model="screenContactorsKeywords" placeholder="请输入任务名称" clearable
            style="width: 300px; margin-right: 10px;" @clear="queryScreenContactorsList(true)"></el-input>
          <el-button @click="queryScreenContactorsList(true)" icon="el-icon-search" circle title="搜索"></el-button>
          <el-button @click="createScreenContactors()" icon="el-icon-plus" circle title="新建"></el-button>
        </el-row>
        <el-table :data="screenContactorsList" stripe v-loading="screenContactorsLoading" height="650">
          <el-table-column prop="task_name" label="任务名称">
          </el-table-column>
          <el-table-column prop="" label="原始文件">
            <template v-slot="scope">
              <el-link type="primary" @click="taskFileDownload(scope.row)">{{ scope.row.file_name }}</el-link>
            </template>
          </el-table-column>
          <el-table-column prop="total" label="总数" width="100">
          </el-table-column>
          <el-table-column prop="creator" label="创建人" width="100">
          </el-table-column>
          <el-table-column prop="created_at" label="创建时间" sortable width="170">
          </el-table-column>
          <el-table-column prop="percentage" label="任务进度" sortable width="170">
            <template v-slot="scope">
              <em v-if="scope.row.paused === true">已暂停</em>
              <em v-else>
                <el-progress :text-inside="true" :stroke-width="15" :percentage="scope.row.percentage"
                  :text-color="scope.row.percentage < 50 ? '#000' : '#FFF'" :color="colors"></el-progress>
              </em>
            </template>
          </el-table-column>
          <el-table-column prop="" label="文件下载">
            <template v-slot="scope">
              <em v-if="!scope.row.download_file">-</em>
              <el-link type="primary" v-if="scope.row.download_file" @click="resultFileDownload(scope.row)">{{
                scope.row.download_file }}</el-link>
            </template>
          </el-table-column>
          <el-table-column prop="" label="操作">
            <template v-slot="scope">
              <el-button v-if="scope.row.percentage >= 100 || 1" type="danger" icon="el-icon-delete"
                @click="screenContactorsTaskDel(scope.row)" title="删除" circle></el-button>
            </template>
          </el-table-column>
        </el-table>
        <div class="pagenation">
          <el-pagination background layout="total, sizes, prev, pager, next" :total="screenContactorsTaskTotal"
            @size-change="changeScreenContactorsTaskSize" @current-change="currentScreenContactorsTaskChange"
            :page-sizes="[10, 20, 50, 100]" :page-size="screenContactorsTaskSize">
          </el-pagination>
        </div>
        <el-dialog title="创建任务 筛选联系人" :visible.sync="createScreenContactorsTaskVisable">
          <el-form :model="createScreenContactorsTaskForm" label-width="120px" :rules="createScreenContactorsTaskRules"
            ref="createScreenContactorsTaskForm" v-loading="createScreenContactorsTaskLoading"
            element-loading-text="正在保存, 请稍候">
            <el-form-item label="任务名称" prop="task_name">
              <el-col :span="20">
                <el-input placeholder="请输入内容" v-model="createScreenContactorsTaskForm.task_name"></el-input>
              </el-col>
            </el-form-item>
            <el-form-item label="选择文件">
              <el-col>
                <el-upload class="upload-demo" :action="uploadApi" :file-list="createScreenContactorsTaskForm.file_list"
                  accept=".xls,.xlsx" :limit="1" :headers="headersObj" :on-success="screenContactorsTaskUploadSuccess">
                  <el-button size="small" type="primary">选择文件</el-button>
                  <div class="el-upload__tip" slot="tip">只能上传xls/xlsx文件</div>
                </el-upload>
              </el-col>
            </el-form-item>
            <el-form-item label="关键词">
              <el-col :span="20">
                <el-tooltip class="item" effect="dark" placement="right">
                  <div slot="content" v-html="screen_contactors_default_keywords"></div>
                  <span>默认词组</span>
                </el-tooltip>
              </el-col>
            </el-form-item>
            <el-form-item label="更多关键词">
              <el-col :span="20">
                <el-input type="textarea" v-model="createScreenContactorsTaskForm.extra_keywords"
                  placeholder="更多关键词, 多个请以英文逗号隔开, 不区分大小写"></el-input>
              </el-col>
            </el-form-item>
            <el-form-item label="补充级别">
              <el-col :span="20">
                <el-select v-model="createScreenContactorsTaskForm.extra_keywords_priority">
                  <el-option key="0" label="优先" value="优先"></el-option>
                  <el-option key="1" label="候补" value="候补"></el-option>
                </el-select>
              </el-col>
            </el-form-item>
          </el-form>
          <div slot="footer" class="dialog-footer">
            <el-button @click="cancelCreateScreenContactorsTask">取 消</el-button>
            <el-button type="primary" @click="saveCreateScreenContactorsTask" v-loading="screenContactorsTaskLoading">保
              存</el-button>
          </div>
        </el-dialog>
      </el-tab-pane>
      <el-tab-pane label="全球搜" name="findBuyers">
        <el-row>
          <el-input v-model="findBuyersKeywords" placeholder="请输入任务名称" clearable
            style="width: 300px; margin-right: 10px;" @clear="queryFindBuyersList(true)"></el-input>
          <el-button @click="queryFindBuyersList(true)" icon="el-icon-search" circle title="搜索"></el-button>
          <el-button @click="createFindBuyersTask()" icon="el-icon-plus" circle title="创建"></el-button>
        </el-row>
        <el-table :data="findBuyersList" stripe v-loading="tableLoading" height="650">
          <el-table-column prop="task_name" label="任务名称">
          </el-table-column>
          <el-table-column prop="" label="原始文件">
            <template v-slot="scope">
              <el-link type="primary" @click="taskFileDownload(scope.row)">{{ scope.row.file_name }}</el-link>
            </template>
          </el-table-column>
          <el-table-column prop="total" label="总数" width="100">
          </el-table-column>
          <el-table-column prop="strict" label="精准匹配" width="100">
            <template v-slot="scope">
              <i :class="scope.row.strict ? 'el-icon-check green' : 'el-icon-close red'"></i>
            </template>
          </el-table-column>
          <el-table-column prop="creator" label="创建人" width="100">
          </el-table-column>
          <el-table-column prop="created_at" label="创建时间" sortable width="170">
          </el-table-column>
          <el-table-column prop="percentage" label="任务进度" sortable width="170"
            :sort-method="(a, b) => { return a.percentage - b.percentage }">
            <template v-slot="scope">
              <em v-if="scope.row.paused === true">已暂停</em>
              <em v-else>
                <el-progress :text-inside="true" :stroke-width="15" :percentage="scope.row.percentage"
                  :text-color="scope.row.percentage < 50 ? '#000' : '#FFF'" :color="colors"></el-progress>
              </em>
            </template>
          </el-table-column>
          <el-table-column prop="" label="文件下载">
            <template v-slot="scope">
              <em v-if="!scope.row.download_file && scope.row.percentage < 100">-</em>
              <em v-if="!scope.row.download_file && scope.row.percentage == 100">正在尝试重新获取空值, 请稍候</em>
              <el-link type="primary" v-if="scope.row.download_file" @click="resultFileDownload(scope.row)">
                {{ scope.row.download_file }}
              </el-link>
            </template>
          </el-table-column>
          <el-table-column prop="" label="操作">
            <template v-slot="scope">
              <el-button v-if="scope.row.percentage >= 100 || scope.row.paused" type="danger" icon="el-icon-delete"
                @click="deepEmailsTaskDel(scope.row)" title="删除" circle></el-button>
              <el-button v-if="scope.row.paused" type="success" icon="el-icon-video-play"
                @click="taskPausedToggle(scope.row)" title="继续" circle></el-button>
              <el-button v-if="!scope.row.paused && scope.row.percentage < 100" type="warning"
                icon="el-icon-video-pause" @click="taskPausedToggle(scope.row)" title="暂停" circle></el-button>
            </template>
          </el-table-column>
        </el-table>
        <div class="pagenation">
          <el-pagination background layout="total, sizes, prev, pager, next" :total="findBuyersTotal"
            @size-change="changeFindBuyersSize" @current-change="currentFindBuyersChange"
            :page-sizes="[10, 20, 50, 100]" :page-size="findBuyersSize">
          </el-pagination>
        </div>
        <el-dialog title="创建任务 全球搜" :visible.sync="createFindBuyersVisable">
          <el-form :model="createFindBuyersForm" label-width="120px" :rules="createFindBuyersRules"
            ref="createFindBuyersForm">
            <el-form-item label="任务名称" prop="task_name">
              <el-col :span="17">
                <el-input placeholder="请输入内容" v-model="createFindBuyersForm.task_name"></el-input>
              </el-col>
            </el-form-item>
            <el-form-item>
              <el-checkbox v-model="createFindBuyersForm.strict">精准匹配</el-checkbox>
            </el-form-item>
            <el-form-item label="选择文件">
              <el-col>
                <el-upload class="upload-demo" drag :action="uploadApi" :file-list="findBuyersFileList"
                  accept=".xls,.xlsx" :limit="1" :headers="headersObj" :on-success="findBuyersUploadSuccess">
                  <i class="el-icon-upload"></i>
                  <div class="el-upload__text">将文件拖到此处，或<em>点击上传</em></div>
                  <div class="el-upload__tip" slot="tip">只能上传xls/xlsx文件</div>
                </el-upload>
              </el-col>
            </el-form-item>
          </el-form>
          <div slot="footer" class="dialog-footer">
            <el-button @click="cancelCreateFindBuyers">取 消</el-button>
            <el-button type="primary" @click="saveCreateFindBuyers" v-loading="findBuyersLoading">保 存</el-button>
          </div>
        </el-dialog>
      </el-tab-pane>
      <el-tab-pane label="邮箱验证" name="emailCheck">
        <el-row>
          <el-input v-model="emailCheckKeywords" placeholder="请输入任务名称" clearable
            style="width: 300px; margin-right: 10px;" @clear="queryEmailCheckList(true)"></el-input>
          <el-button @click="queryEmailCheckList(true)" icon="el-icon-search" circle title="搜索"></el-button>
          <el-button @click="createEmailCheckTask()" icon="el-icon-plus" circle title="创建"></el-button>
        </el-row>
        <el-table :data="emailCheckList" stripe v-loading="tableLoading" height="650">
          <el-table-column prop="task_name" label="任务名称">
          </el-table-column>
          <el-table-column prop="" label="原始文件">
            <template v-slot="scope">
              <el-link type="primary" @click="taskFileDownload(scope.row)">{{ scope.row.file_name }}</el-link>
            </template>
          </el-table-column>
          <el-table-column prop="server" label="验证服务器" width="170">
            <template v-slot="scope">
              <el-tooltip class="item" effect="dark" :content="scope.row.server" placement="top"
                v-if="scope.row.server != null && scope.row.server.length >= 18">
                <span>
                  {{ scope.row.server.substring(0, 18) + '...' }}
                </span>
              </el-tooltip>
              <span v-else>{{ scope.row.server }}</span>
            </template>
          </el-table-column>
          <el-table-column prop="total" label="总数" width="100">
          </el-table-column>
          <el-table-column prop="creator" label="创建人" width="100">
          </el-table-column>
          <el-table-column prop="created_at" label="创建时间" sortable width="170">
          </el-table-column>
          <el-table-column prop="percentage" label="任务进度" sortable width="170"
            :sort-method="(a, b) => { return a.percentage - b.percentage }">
            <template v-slot="scope">
              <em v-if="scope.row.paused === true">已暂停</em>
              <em v-else>
                <el-progress :text-inside="true" :stroke-width="15" :percentage="scope.row.percentage"
                  :text-color="scope.row.percentage < 50 ? '#000' : '#FFF'" :color="colors"></el-progress>
              </em>
            </template>
          </el-table-column>
          <el-table-column prop="" label="文件下载">
            <template v-slot="scope">
              <em v-if="!scope.row.download_file && scope.row.percentage < 100">-</em>
              <em v-if="!scope.row.download_file && scope.row.percentage == 100">正在生成文件, 请稍候</em>
              <el-link type="primary" v-if="scope.row.download_file" @click="resultFileDownload(scope.row)">
                {{ scope.row.download_file }}
              </el-link>
            </template>
          </el-table-column>
          <el-table-column prop="" label="操作">
            <template v-slot="scope">
              <el-button v-if="scope.row.percentage >= 100 || scope.row.percentage === 0 || scope.row.paused"
                type="danger" icon="el-icon-delete" @click="deepEmailsTaskDel(scope.row)" title="删除" circle></el-button>
              <el-button v-if="scope.row.paused" type="success" icon="el-icon-video-play"
                @click="taskPausedToggle(scope.row)" title="继续" circle></el-button>
              <el-button v-if="!scope.row.paused && scope.row.percentage > 0 && scope.row.percentage < 100"
                type="warning" icon="el-icon-video-pause" @click="taskPausedToggle(scope.row)" title="暂停"
                circle></el-button>
              <el-button v-if="!scope.row.paused && scope.row.percentage === 0" type="danger"
                icon="el-icon-switch-button" @click="taskPausedToggle(scope.row)" title="终止" circle></el-button>
            </template>
          </el-table-column>
        </el-table>
        <div class="pagenation">
          <el-pagination background layout="total, sizes, prev, pager, next" :total="emailCheckTotal"
            @size-change="changeEmailCheckSize" @current-change="currentEmailCheckChange"
            :page-sizes="[10, 20, 50, 100]" :page-size="emailCheckSize">
          </el-pagination>
        </div>
        <el-dialog title="创建任务 邮箱验证" :visible.sync="createEmailCheckVisable" v-loading="createEmailCheckFullLoading"
          element-loading-text="正在保存, 请稍候">
          <el-form :model="createEmailCheckForm" label-width="120px" :rules="createEmailCheckRules"
            ref="createEmailCheckForm">
            <el-form-item label="任务名称" prop="task_name">
              <el-col :span="17">
                <el-input placeholder="请输入内容" v-model="createEmailCheckForm.task_name"></el-input>
              </el-col>
            </el-form-item>
            <el-form-item label="选择文件">
              <el-col>
                <el-upload class="upload-demo" drag :action="uploadApi" :file-list="emailCheckFileList"
                  accept=".xls,.xlsx" :limit="1" :headers="headersObj" :on-success="emailCheckUploadSuccess">
                  <i class="el-icon-upload"></i>
                  <div class="el-upload__text">将文件拖到此处，或<em>点击上传</em></div>
                  <div class="el-upload__tip" slot="tip">只能上传xls/xlsx文件</div>
                </el-upload>
              </el-col>
            </el-form-item>
            <el-form-item label="验证服务器">
              <el-col :span="20">
                <el-select v-model="createEmailCheckForm.email_server_id" v-loading="createEmailCheckLoading"
                  placeholder="请选择" filterable>
                  <el-option v-for="item in emailServers" :key="item.id" :label="item.server" :value="item.id">
                  </el-option>
                </el-select>
              </el-col>
            </el-form-item>
          </el-form>
          <div slot="footer" class="dialog-footer">
            <el-button @click="cancelCreateEmailCheck">取 消</el-button>
            <el-button type="primary" @click="saveCreateEmailCheck" v-loading="emailCheckLoading">保 存</el-button>
          </div>
        </el-dialog>
      </el-tab-pane>
      <el-tab-pane label="域名筛选" name="screenDomains">
        <el-row>
          <el-input v-model="domainsKeywords" placeholder="请输入域名关键字" clearable style="width: 300px; margin-right: 10px;"
            @clear="queryDomainsList(true)"></el-input>
          <el-button @click="queryDomainsList(true)" icon="el-icon-search" circle title="搜索"></el-button>
          <el-button @click="createScreenDomainsTask()" icon="el-icon-magic-stick" circle title="筛选"></el-button>
          <el-button @click="uploadDomainsData()" icon="el-icon-upload2" circle title="上传元数据"></el-button>
        </el-row>
        <el-table :data="domainsList" stripe v-loading="domainsLoading" height="650">
          <el-table-column prop="A" label="公司名">
          </el-table-column>
          <el-table-column prop="B" label="域名">
          </el-table-column>
        </el-table>
        <div class="pagenation">
          <el-pagination background layout="total, sizes, prev, pager, next" :total="domainsTotal"
            @size-change="changeDomainsSize" @current-change="currentDomainsChange" :page-sizes="[100, 200, 500, 1000]"
            :page-size="domainsSize">
          </el-pagination>
        </div>
        <el-dialog title="上传元数据" :visible.sync="uploadDomainsDataVisible">
          <el-form :model="uploadDomainsDataForm" label-width="80px" v-loading="uploadDomainsDataLoading"
            element-loading-text="正在上传, 请稍候">
            <el-form-item label="选择文件" prop="uploadDomainsFileList">
              <el-upload class="upload-demo" drag :action="uploadApi" multiple :limit="10"
                :file-list="uploadDomainsDataForm.uploadDomainsFileList" :headers="headersObj"
                :on-change="domainsDataUploadSuccess">
                <i class="el-icon-upload"></i>
                <div class="el-upload__text">将文件拖到此处，或<em>点击上传</em></div>
                <div class="el-upload__tip" slot="tip"><i class="el-icon-info"></i> 只能上传xls/xlsx文件</div>
              </el-upload>
            </el-form-item>
          </el-form>
          <div slot="footer" class="dialog-footer">
            <el-button @click="uploadDomainsDataVisible = false">取 消</el-button>
            <el-button type="primary" @click="saveUploadDomainsData">上 传</el-button>
          </div>
        </el-dialog>
        <el-dialog title="公司域名筛选" :visible.sync="doScreenDomainsVisible">
          <el-form :model="doScreenDomainsForm" label-width="80px">
            <el-form-item label="原始文件" prop="doScreenDomainsFileList">
              <el-upload class="upload-demo" drag :action="uploadApi"
                :file-list="doScreenDomainsForm.doScreenDomainsFileList" :headers="headersObj"
                :on-change="doScreenDomainsUploadSuccess">
                <i class="el-icon-upload"></i>
                <div class="el-upload__text">将文件拖到此处，或<em>点击上传</em></div>
                <div class="el-upload__tip" slot="tip"><i class="el-icon-info"></i> 请在右下角点击上传 完成后再点击开始</div>
              </el-upload>
            </el-form-item>
            <el-form-item v-if="doScreenDomainsPercentage > 0">
              <el-progress :percentage="doScreenDomainsPercentage" :color="colors" :text-inside="true"
                :stroke-width="20" :text-color="doScreenDomainsPercentage < 50 ? '#000' : '#FFF'"></el-progress>
            </el-form-item>
            <el-form-item v-if="doScreenDomainsResult.download_file !== ''">
              <el-link type="primary" @click="resultFileDownload(doScreenDomainsResult)">
                {{ doScreenDomainsResult.download_file }}
              </el-link>
            </el-form-item>
          </el-form>
          <div slot="footer" class="dialog-footer">
            <el-button @click="doScreenDomainsVisible = false">取 消</el-button>
            <el-button v-if="screenDomainsId === ''" type="primary" @click="startScreenDomains">上 传</el-button>
            <el-button v-if="screenDomainsId !== ''" type="primary" @click="doStartScreenDomains">开 始</el-button>
          </div>
        </el-dialog>
      </el-tab-pane>
      <el-tab-pane label="回收站" name="recycle">
        <el-row>
          <el-input v-model="recycleKeywords" placeholder="请输入关键词" clearable style="width: 300px; margin-right: 10px;"
            @clear="queryRecycleList()"></el-input>
          <el-button @click="queryRecycleList()" icon="el-icon-search" circle title="搜索"></el-button>
        </el-row>
        <el-table :data="recycleList" stripe v-loading="tableLoading" height="650">
          <el-table-column prop="task_name" label="任务名称">
          </el-table-column>
          <el-table-column prop="" label="原始文件">
            <template v-slot="scope">
              <el-link type="primary" @click="taskFileDownload(scope.row)">{{ scope.row.file_name }}</el-link>
            </template>
          </el-table-column>
          <el-table-column prop="total" label="总数" width="100">
          </el-table-column>
          <el-table-column prop="creator" label="创建人" width="100">
          </el-table-column>
          <el-table-column prop="created_at" label="创建时间" sortable width="170">
          </el-table-column>
          <el-table-column prop="type" label="任务类型" sortable width="100">
          </el-table-column>
          <el-table-column prop="" label="操作">
            <template v-slot="scope">
              <el-button type="success" icon="el-icon-refresh-left" @click="recycleRestore(scope.row)" title="还原"
                circle></el-button>
              <el-button type="danger" icon="el-icon-delete" @click="recycleDel(scope.row)" title="彻底删除"
                circle></el-button>
            </template>
          </el-table-column>
        </el-table>
        <div class="pagenation">
          <el-pagination background layout="total, sizes, prev, pager, next" :total="recycleTotal"
            @size-change="changeRecycleSize" @current-change="currentRecycleChange" :page-sizes="[10, 20, 50, 100]"
            :page-size="recycleSize">
          </el-pagination>
        </div>
      </el-tab-pane>
    </el-tabs>
  </div>
</template>

<script>
import Nav from '../Global/Nav.vue'
export default {
  name: 'DeepMails',
  components: {
    Nav
  },
  data() {
    return {
      activeName: 'deepMailsTask',
      // activeName: 'screenDomains',
      uploadApi: this.$axios.defaults.baseURL + 'excel/upload',
      headersObj: {
        'x-authorization-token': this.$userinfo.api_token
      },
      colors: [
        { color: '#1989fa', percentage: 10 },
        { color: '#19bafa', percentage: 20 },
        { color: '#19eefa', percentage: 30 },
        { color: '#19fabe', percentage: 40 },
        { color: '#19fa7f', percentage: 50 },
        { color: '#25fa19', percentage: 60 },
        { color: '#97fa19', percentage: 70 },
        { color: '#8619fa', percentage: 80 },
        { color: '#fa7819', percentage: 90 },
        { color: '#fa1919', percentage: 100 }
      ],
      taskFileList: [],
      taskKeywords: '',
      taskSize: 10,
      taskCurrentPage: 1,
      taskTotal: 0,
      tableLoading: false,
      deepEmailsTaskList: [],
      deepMailsTaskLoading: false,
      createTaskVisable: false,
      createTaskData: [],
      createTaskForm: {
        task_name: '',
        type: 'DEEPEMAILS'
      },
      createTaskRules: {
        task_name: [
          { required: true, message: '任务名称不能为空', trigger: 'commit' }
        ]
      },
      tradeDataTaskFileList: [],
      tradeDataTaskKeywords: '',
      tradeDataTaskSize: 10,
      tradeDataTaskCurrentPage: 1,
      tradeDataTaskTotal: 0,
      tradeDataTaskList: [],
      tradeDataTaskLoading: false,
      createTradeDataTaskVisable: false,
      createTradeDataTaskData: [],
      createTradeDataTaskForm: {
        task_name: '',
        type: 'TRADEENTERPRISE'
      },
      createTradeDataTaskRules: {
        task_name: [
          { required: true, message: '任务名称不能为空', trigger: 'commit' }
        ]
      },
      recycleList: [],
      recycleKeywords: '',
      recycleTotal: 0,
      recycleSize: 10,
      recycleCurrentPage: 1,
      screenContactorsKeywords: '',
      screenContactorsLoading: false,
      screenContactorsList: [],
      screenContactorsTaskTotal: 0,
      screenContactorsTaskSize: 10,
      screenContactorsTaskPage: 1,
      screen_contactors_default_keywords: '',
      createScreenContactorsTaskLoading: false,
      createScreenContactorsTaskVisable: false,
      createScreenContactorsTaskForm: {
        task_name: '',
        file_list: [],
        extra_keywords: null,
        extra_keywords_priority: '优先'
      },
      createScreenContactorsTaskRules: {},
      screenContactorsTaskFileList: [],
      screenContactorsTaskLoading: false,
      // 找买家
      findBuyersKeywords: '',
      findBuyersList: [],
      findBuyersTotal: 0,
      findBuyersSize: 10,
      findBuyersCurrentPage: 1,
      createFindBuyersVisable: false,
      createFindBuyersForm: {
        task_name: '',
        type: 'FINDBUYERS',
        strict: true
      },
      createFindBuyersRules: {},
      findBuyersFileList: [],
      findBuyersLoading: false,
      // 邮箱验证
      emailCheckKeywords: '',
      emailCheckList: [],
      emailCheckTotal: 0,
      emailCheckSize: 10,
      emailCheckCurrentPage: 1,
      createEmailCheckVisable: false,
      createEmailCheckForm: {
        task_name: '',
        type: 'EMAILCHECK',
        email_server_id: null
      },
      createEmailCheckRules: {},
      emailCheckFileList: [],
      emailCheckLoading: false,
      createEmailCheckFullLoading: false,
      createEmailCheckLoading: false,
      emailServers: [],

      domainsKeywords: '',
      domainsLoading: false,
      domainsList: [],
      domainsTotal: 0,
      domainsSize: 100,
      domainsCurrentPage: 1,
      uploadDomainsDataVisible: false,
      uploadDomainsDataForm: {
        uploadDomainsFileList: []
      },
      uploadDomainsDataLoading: false,
      doScreenDomainsVisible: false,
      doScreenDomainsForm: {
        doScreenDomainsFileList: []
      },
      doScreenDomainsPercentage: 0,
      doScreenDomainsResult: {
        download_storage_path: '',
        download_file: ''
      },
      screenDomainsId: ''
    }
  },
  mounted() {
    this.queryDeepEmailsTaskList();
    this.intervals = setInterval(() => {
      if (this.activeName === 'deepMailsTask') {
        this.queryDeepEmailsTaskList(false, true);
      } else if (this.activeName === 'tradeDataTask') {
        this.queryTradeDataTaskList(false, true);
      } else if (this.activeName === 'findBuyers') {
        this.queryFindBuyersList(false, true);
      } else if (this.activeName === 'emailCheck') {
        this.queryEmailCheckList(false, true);
      }
    }, 10000);
  },
  methods: {
    tabClick(tab, event) {
      switch (tab.name) {
        case 'deepMailsTask':
          this.queryDeepEmailsTaskList();
          break;
        case 'tradeDataTask':
          this.queryTradeDataTaskList();
          break;
        case 'screenContactors':
          this.queryScreenContactorsList();
          this.getScreenContactorsOptions();
          break;
        case 'findBuyers':
          this.queryFindBuyersList();
          break;
        case 'emailCheck':
          this.queryEmailCheckList();
          break;
        case 'screenDomains':
          this.queryDomainsList();
          break;
        case 'recycle':
          this.queryRecycleList();
          break;
      }
    },
    queryDeepEmailsTaskList(search = false, iv = false) {
      if (iv === false) {
        this.tableLoading = true;
      }
      let current_page = search === true ? 1 : this.taskCurrentPage;
      this.$axios.get(`email/fumeng/task_list`, {
        params: {
          keywords: this.taskKeywords,
          size: this.taskSize,
          page: current_page,
          type: 'DEEPEMAILS'
        }
      }).then((response) => {
        this.tableLoading = false;
        if (response.data.code === 200) {
          this.deepEmailsTaskList = response.data.data.data
          this.taskTotal = response.data.data.total
        }
      });
    },
    changeTaskSize(val) {
      this.taskSize = val;
      this.queryDeepEmailsTaskList();
    },
    currentTaskChange(val) {
      this.taskCurrentPage = val;
      this.queryDeepEmailsTaskList();
    },
    createTask() {
      this.createTaskVisable = true
    },
    taskUploadSuccess(response) {
      this.taskFileList = [];
      if (response.code === 200) {
        this.taskFileList.push(response.data)
      } else {
        this.$notify({
          title: 'failed',
          message: response.data,
          type: 'warning'
        })
      }
    },
    cancelCreateTask() {
      this.taskFileList = [];
      this.createTaskVisable = false
    },
    saveCreateTask() {
      if (this.taskFileList.length < 1) {
        this.$notify({
          title: 'failed',
          message: '请选择文件',
          type: 'warning'
        })
        return false;
      }
      this.$refs.createTaskForm.validate(valid => {
        if (valid) {
          this.$notify({
            'title': '提示',
            'message': '正在保存, 请稍候',
            'type': 'info'
          })
          this.$axios.post('email/fumeng/create_task', {
            task_name: this.createTaskForm.task_name,
            file_name: this.taskFileList[0].name,
            file_path: this.taskFileList[0].url,
            type: this.createTaskForm.type
          }).then((response) => {
            if (response.data.code === 200) {
              this.$notify({
                'title': 'success',
                'message': '创建成功',
                'type': 'success'
              })
              this.createTaskVisable = false;
              this.createTaskForm.task_name = '';
              this.taskFileList = [];
              this.queryDeepEmailsTaskList();
            }
          })
        }
      })
    },
    deepEmailsTaskDel(row) {
      this.$confirm('确定删除吗?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.$axios.post('email/fumeng/delete_task', {
          id: row.id
        }).then((response) => {
          let code = response.data.code;
          if (code === 200) {
            this.$message({
              type: 'success',
              message: '删除成功!'
            });
            this.queryDeepEmailsTaskList();
            this.queryTradeDataTaskList();
            this.queryFindBuyersList();
            this.queryEmailCheckList();
          } else {
            this.$notify({
              title: 'failed',
              message: response.data.data,
              type: 'error'
            })
          }
        })
      })
    },
    queryTradeDataTaskList(search = false, iv = false) {
      if (iv === false) {
        this.tableLoading = true;
      }
      let current_page = search === true ? 1 : this.tradeDataTaskCurrentPage;
      this.$axios.get(`email/fumeng/task_list`, {
        params: {
          keywords: this.tradeDataTaskKeywords,
          size: this.tradeDataTaskSize,
          page: current_page,
          type: 'TRADEENTERPRISE'
        }
      }).then((response) => {
        this.tableLoading = false;
        if (response.data.code === 200) {
          this.tradeDataTaskList = response.data.data.data
          this.tradeDataTaskTotal = response.data.data.total
        }
      });
    },
    changeTradeDataTaskSize(val) {
      this.tradeDataTaskSize = val;
      this.queryTradeDataTaskList();
    },
    currentTradeDataTaskChange(val) {
      this.tradeDataTaskCurrentPage = val;
      this.queryTradeDataTaskList();
    },
    createTradeDataTask() {
      this.createTradeDataTaskVisable = true
    },
    tradeDataTaskUploadSuccess(response) {
      this.tradeDataTaskFileList = [];
      if (response.code === 200) {
        this.tradeDataTaskFileList.push(response.data)
      } else {
        this.$notify({
          title: 'failed',
          message: response.data,
          type: 'warning'
        })
      }
    },
    cancelCreateTradeDataTask() {
      this.tradeDataTaskFileList = [];
      this.createTradeDataTaskVisable = false
    },
    saveCreateTradeDataTask() {
      if (this.tradeDataTaskFileList.length < 1) {
        this.$notify({
          title: 'failed',
          message: '请选择文件',
          type: 'warning'
        })
        return false;
      }
      this.$refs.createTradeDataTaskForm.validate(valid => {
        if (valid) {
          this.$notify({
            'title': '提示',
            'message': '正在保存, 请稍候',
            'type': 'info'
          })
          this.$axios.post('email/fumeng/create_task', {
            task_name: this.createTradeDataTaskForm.task_name,
            file_name: this.tradeDataTaskFileList[0].name,
            file_path: this.tradeDataTaskFileList[0].url,
            type: this.createTradeDataTaskForm.type
          }).then((response) => {
            if (response.data.code === 200) {
              this.$notify({
                'title': 'success',
                'message': '创建成功',
                'type': 'success'
              })
              this.createTradeDataTaskVisable = false;
              this.createTradeDataTaskForm.task_name = '';
              this.tradeDataTaskFileList = [];
              this.queryTradeDataTaskList();
            }
          })
        }
      })
    },
    taskFileDownload(row) {
      window.location.href = this.$axios.defaults.baseURL + 'files/download?url=' + row.file_path + '&savename=' + row.file_name;
    },
    resultFileDownload(row) {
      window.location.href = this.$axios.defaults.baseURL + 'files/download?url=' + row.download_storage_path + '&savename=' + row.download_file;
    },
    deepTradeDataTaskDel(row) {
      this.$confirm('确定删除吗?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.$axios.post('email/fumeng/delete_task', {
          id: row.id
        }).then((response) => {
          let code = response.data.code;
          if (code === 200) {
            this.$message({
              type: 'success',
              message: '删除成功!'
            });
            this.queryTradeDataTaskList();
          } else {
            this.$notify({
              title: 'failed',
              message: response.data.data,
              type: 'error'
            })
          }
        })
      })
    },
    taskPausedToggle(row) {
      this.$axios.post('email/fumeng/task_toggle_status', {
        id: row.id,
        paused: row.paused ? 0 : 1
      }).then((response) => {
        this.queryTradeDataTaskList();
        this.queryFindBuyersList();
      })
    },
    queryRecycleList(iv = false) {
      if (iv === false) {
        this.tableLoading = true;
      }
      this.$axios.get(`center/data/recycle_list`, {
        params: {
          keywords: this.recycleKeywords,
          size: this.recycleSize,
          page: this.recycleCurrentPage,
          module: 'FUMAMX'
        }
      }).then((response) => {
        this.tableLoading = false;
        if (response.data.code === 200) {
          this.recycleList = response.data.data.data
          this.recycleTotal = response.data.data.total
        }
      });
    },
    changeRecycleSize(val) {
      this.recycleSize = val;
      this.queryRecycleList();
    },
    currentRecycleChange(val) {
      this.recycleCurrentPage = val;
      this.queryRecycleList();
    },
    recycleRestore(row) {
      this.$confirm('确定还原吗?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'info'
      }).then(() => {
        this.$axios.post('center/data/recycle_restore', {
          id: row.id,
          module: 'FUMAMX'
        }).then((response) => {
          let code = response.data.code;
          if (code === 200) {
            this.$message({
              type: 'success',
              message: '操作成功!'
            });
            this.queryRecycleList();
          } else {
            this.$notify({
              title: 'failed',
              message: response.data.data,
              type: 'error'
            })
          }
        })
      })
    },
    recycleDel(row) {
      this.$confirm('此操作不可恢复, 确定吗?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'info'
      }).then(() => {
        this.$axios.post('center/data/recycle_delete', {
          id: row.id,
          module: 'FUMAMX'
        }).then((response) => {
          let code = response.data.code;
          if (code === 200) {
            this.$message({
              type: 'success',
              message: '操作成功!'
            });
            this.queryRecycleList();
          } else {
            this.$notify({
              title: 'failed',
              message: response.data.data,
              type: 'error'
            })
          }
        })
      })
    },
    queryScreenContactorsList(search = false, iv = false) {
      if (iv === false) {
        this.tableLoading = true;
      }
      let current_page = search === true ? 1 : this.screenContactorsTaskPage;
      this.$axios.get(`center/tools/screen_contactors/list`, {
        params: {
          keywords: this.screenContactorsKeywords,
          size: this.screenContactorsTaskSize,
          page: current_page
        }
      }).then((response) => {
        this.tableLoading = false;
        if (response.data.code === 200) {
          this.screenContactorsList = response.data.data.data
          this.screenContactorsTaskTotal = response.data.data.total
        }
      });
    },
    changeScreenContactorsTaskSize(val) {
      this.screenContactorsTaskSize = val;
      this.queryScreenContactorsList();
    },
    currentScreenContactorsTaskChange(val) {
      this.screenContactorsTaskPage = val;
      this.queryScreenContactorsList();
    },
    screenContactorsTaskUploadSuccess(response) {
      this.createScreenContactorsTaskForm.file_list = [];
      if (response.code === 200) {
        this.createScreenContactorsTaskForm.file_list.push(response.data)
      } else {
        this.$notify({
          title: 'failed',
          message: response.data,
          type: 'warning'
        })
      }
    },
    getScreenContactorsOptions() {
      this.$axios.get(`center/tools/screen_contactors/options?type=default_keywords`).then((response) => {
        if (response.data.code === 200) {
          this.screen_contactors_default_keywords = response.data.data.join("<br>")
        }
      });
    },
    createScreenContactors() {
      this.createScreenContactorsTaskVisable = true;
    },
    cancelCreateScreenContactorsTask() {
      this.createScreenContactorsTaskVisable = false;
      this.createScreenContactorsTaskForm = {
        task_name: '',
        file_list: [],
        extra_keywords: null,
        extra_keywords_priority: '优先'
      };
    },
    saveCreateScreenContactorsTask() {
      this.createScreenContactorsTaskLoading = true;
      this.$axios.post('center/tools/screen_contactors/create', this.createScreenContactorsTaskForm).then((response) => {
        this.createScreenContactorsTaskLoading = false;
        if (response.data.code === 200) {
          this.$notify({
            title: '添加成功',
            message: '添加成功',
            type: 'success'
          });
          this.createScreenContactorsTaskVisable = false;
          this.createScreenContactorsTaskForm = {
            task_name: '',
            file_list: [],
            extra_keywords: null,
            extra_keywords_priority: '优先'
          };
          this.queryScreenContactorsList();
        }
      })
    },
    screenContactorsTaskDel(row) {
      this.$confirm('此操作将永久删除该文件, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.$axios.post('center/tools/screen_contactors/delete', {
          id: row.id
        }).then((response) => {
          if (response.data.code === 200) {
            this.$notify({
              title: '删除成功',
              message: '删除成功',
              type: 'success'
            });
            this.queryScreenContactorsList();
          }
        })
      })
    },
    createFindBuyersTask() {
      this.createFindBuyersVisable = true
    },
    queryFindBuyersList(search = false, iv = false) {
      if (iv === false) {
        this.tableLoading = true;
      }
      let current_page = search === true ? 1 : this.findBuyersCurrentPage;
      this.$axios.get(`email/fumeng/task_list`, {
        params: {
          keywords: this.findBuyersKeywords,
          size: this.findBuyersSize,
          page: current_page,
          type: 'FINDBUYERS'
        }
      }).then((response) => {
        this.tableLoading = false;
        if (response.data.code === 200) {
          this.findBuyersList = response.data.data.data
          this.findBuyersTotal = response.data.data.total
        }
      });
    },
    changeFindBuyersSize(val) {
      this.findBuyersSize = val;
      this.queryFindBuyersList();
    },
    currentFindBuyersChange(val) {
      this.findBuyersCurrentPage = val;
      this.queryFindBuyersList();
    },
    createFindBuyers() {
      this.findBuyersVisable = true
    },
    findBuyersUploadSuccess(response) {
      this.findBuyersFileList = [];
      if (response.code === 200) {
        this.findBuyersFileList.push(response.data)
      } else {
        this.$notify({
          title: 'failed',
          message: response.data,
          type: 'warning'
        })
      }
    },
    cancelCreateFindBuyers() {
      this.findBuyersFileList = [];
      this.createFindBuyersVisable = false
    },
    saveCreateFindBuyers() {
      if (this.findBuyersFileList.length < 1) {
        this.$notify({
          title: 'failed',
          message: '请选择文件',
          type: 'warning'
        })
        return false;
      }
      this.$refs.createFindBuyersForm.validate(valid => {
        if (valid) {
          this.$notify({
            'title': '提示',
            'message': '正在保存, 请稍候',
            'type': 'info'
          })
          this.$axios.post('email/fumeng/create_task', {
            task_name: this.createFindBuyersForm.task_name,
            file_name: this.findBuyersFileList[0].name,
            file_path: this.findBuyersFileList[0].url,
            type: this.createFindBuyersForm.type,
            strict: this.createFindBuyersForm.strict
          }).then((response) => {
            if (response.data.code === 200) {
              this.$notify({
                'title': 'success',
                'message': '创建成功',
                'type': 'success'
              })
              this.createFindBuyersVisable = false;
              this.createFindBuyersForm.task_name = '';
              this.findBuyersFileList = [];
              this.queryFindBuyersList();
            }
          })
        }
      })
    },
    createEmailCheckTask() {
      this.createEmailCheckLoading = true;
      this.$axios.get(`center/data/email_servers`).then((response) => {
        this.createEmailCheckLoading = false;
        if (response.data.code === 200) {
          this.emailServers = response.data.data;
        }
      });
      setTimeout(() => {
        this.createEmailCheckVisable = true
      }, 0);
    },
    queryEmailCheckList(search = false, iv = false) {
      if (iv === false) {
        this.tableLoading = true;
      }
      let current_page = search === true ? 1 : this.emailCheckCurrentPage;
      this.$axios.get(`email/fumeng/task_list`, {
        params: {
          keywords: this.emailCheckKeywords,
          size: this.emailCheckSize,
          page: current_page,
          type: 'EMAILCHECK'
        }
      }).then((response) => {
        this.tableLoading = false;
        if (response.data.code === 200) {
          this.emailCheckList = response.data.data.data
          this.emailCheckTotal = response.data.data.total
        }
      });
    },
    changeEmailCheckSize(val) {
      this.emailCheckSize = val;
      this.queryEmailCheckList();
    },
    currentEmailCheckChange(val) {
      this.emailCheckCurrentPage = val;
      this.queryEmailCheckList();
    },
    createEmailCheck() {
      this.createEmailCheckVisable = true
    },
    emailCheckUploadSuccess(response) {
      this.emailCheckFileList = [];
      if (response.code === 200) {
        this.emailCheckFileList.push(response.data)
      } else {
        this.$notify({
          title: 'failed',
          message: response.data,
          type: 'warning'
        })
      }
    },
    cancelCreateEmailCheck() {
      this.emailCheckFileList = [];
      this.createEmailCheckForm = {
        task_name: '',
        type: 'EMAILCHECK',
        email_server_id: null
      };
      this.createEmailCheckVisable = false
    },
    saveCreateEmailCheck() {
      if (this.emailCheckFileList.length < 1) {
        this.$notify({
          title: 'failed',
          message: '请选择文件',
          type: 'warning'
        })
        return false;
      }
      this.$refs.createEmailCheckForm.validate(valid => {
        if (valid) {
          this.createEmailCheckFullLoading = true;
          this.$axios.post('email/fumeng/create_task', {
            task_name: this.createEmailCheckForm.task_name,
            file_name: this.emailCheckFileList[0].name,
            file_path: this.emailCheckFileList[0].url,
            type: this.createEmailCheckForm.type,
            email_server_id: this.createEmailCheckForm.email_server_id
          }).then((response) => {
            this.createEmailCheckFullLoading = false;
            if (response.data.code === 200) {
              this.$notify({
                'title': 'success',
                'message': '创建成功',
                'type': 'success'
              })
              this.createEmailCheckVisable = false;
              this.createEmailCheckForm = {
                task_name: '',
                type: 'EMAILCHECK',
                email_server_id: null
              };
              this.emailCheckFileList = [];
              this.queryEmailCheckList();
            }
          })
        }
      })
    },
    domainsDataUploadSuccess(file, fileList) {
      this.uploadDomainsDataForm.uploadDomainsFileList = fileList;
    },
    uploadDomainsData() {
      this.uploadDomainsDataVisible = true;
    },
    saveUploadDomainsData() {
      this.uploadDomainsDataLoading = true;
      this.$axios.post('center/tools/screen_domains/upload', this.uploadDomainsDataForm).then((response) => {
        this.uploadDomainsDataLoading = false;
        if (response.data.code === 200) {
          this.$notify({
            title: 'success',
            message: '上传成功, 本次总计新增' + response.data.data + '条',
            type: 'success',
            duration: 0
          });
          this.uploadDomainsDataForm = {
            uploadDomainsFileList: []
          }
          this.uploadDomainsDataVisible = false;
          this.queryDomainsList();
        }
      })
    },
    queryDomainsList(search = false) {
      let current_page = search === true ? 1 : this.domainsCurrentPage;
      this.$axios.get(`center/tools/screen_domains/list`, {
        params: {
          keywords: this.domainsKeywords,
          size: this.domainsSize,
          page: current_page
        }
      }).then((response) => {
        this.domainsLoading = false;
        if (response.data.code === 200) {
          this.domainsList = response.data.data.data
          this.domainsTotal = response.data.data.total
        }
      });
    },
    createScreenDomainsTask() {
      this.doScreenDomainsVisible = true;
    },
    doScreenDomainsUploadSuccess(file, fileList) {
      this.doScreenDomainsForm.doScreenDomainsFileList = fileList;
    },
    startScreenDomains() {
      this.$axios.post(`center/tools/screen_domains/start`, this.doScreenDomainsForm).then((response) => {
        if (response.data.code === 200) {
          this.screenDomainsId = response.data.data;
          this.$notify({
            title: 'success',
            message: '上传成功 请点击开始',
            type: 'success'
          });
        } else {
          this.$notify({
            title: '操作失败',
            message: response.data.data,
            type: 'warning'
          });
        }
      })
    },
    doStartScreenDomains() {
      this.queryDoStartScreenProgress();
      this.$notify({
        title: 'success',
        message: '操作成功 请勿关闭或刷新页面',
        type: 'success',
        duration: 0
      });
      this.$axios.post(`center/tools/screen_domains/real_start`, {
        id: this.screenDomainsId
      })
    },
    queryDoStartScreenProgress() {
      this.$axios.get(`center/tools/screen_domains/progress?id=` + this.screenDomainsId).then((response) => {
        if (response.data.code === 200) {
          if (!isNaN(response.data.data.progress)) {
            this.doScreenDomainsPercentage = response.data.data.progress;
            var screenInterval = setTimeout(() => {
              this.queryDoStartScreenProgress(true)
            }, 500)
          } else {
            this.doScreenDomainsPercentage = 100;
            this.doScreenDomainsResult = response.data.data;
            clearTimeout(screenInterval);
          }
        }
      })
    },
    changeDomainsSize(val) {
      this.domainsListSize = val;
      this.queryDomainsList();
    },
    currentDomainsChange(val) {
      this.domainsCurrentPage = val;
      this.queryDomainsList();
    }
  },
  beforeDestroy() {
    clearInterval(this.intervals);
  }
}
</script>

<style scoped>
.green {
  color: #409EFF;
}

.red {
  color: red;
}

.el-progress /deep/ :hover>.el-progress-bar__innerText {
  color: #000 !important;
  cursor: default;
}
</style>


// WEBPACK FOOTER //
// src/components/Modules/DeepEmails.vue